import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PropiedadesRuralesService {
  baseUrl = environment.baseUrl;

  constructor(private httpClient: HttpClient) { }

  getPropiedadRural(id) {
    return this.httpClient.get(this.baseUrl + '/propiedades-rurales/' + id);
  }

  getPropiedadesRurales() {
    return this.httpClient.get(this.baseUrl + '/propiedades-rurales');
  }

  getDepartamentos() {
    return this.httpClient.get(this.baseUrl + '/departamentos');
  }

}
